module.exports = __webpack_public_path__ + "img/amazon.2ec6a436.svg";